<!-- <div class="container">
  <div class="row header">
    <div class="clo-md-12 m-r-5-a">

    </div>
    <div class="row mt-5">
      <div class="col-md-2">
        <app-net-navbarpage  [userDataInput]="'home'"></app-net-navbarpage>
      </div>
      <div class="col-md-7 postContained wd">
        <app-bussiness-post [postView]="'NETWORK'"></app-bussiness-post>
      </div>
      <div class="col-md-3">
        <app-common-widget [page]="'NETWORK_HOME_PAGE'" [inputData]="'NETWORK'"></app-common-widget>
      </div>
    </div>
  </div>
</div> -->
<!-- <div class="col-md-10 padding-0"> -->
  <div class="all-page-combo-layout">
    <div class="all-page-feed">
      <app-bussiness-post [postView]="'NETWORK'"></app-bussiness-post>
    </div>
    <div class="all-page-widget">
      <app-common-widget [page]="'NETWORK_HOME_PAGE'" [inputData]="'NETWORK'"></app-common-widget>
    </div>
  </div>
<!-- </div> -->
